<template>
  <div>
    <el-carousel height="23.75rem">
      <el-carousel-item v-for="(item, index) in banners" :key="index">
        <img :src="item.img" class="object-cover object-center w-full h-full" @click="toPath(item.link)"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";

export default defineComponent({
  props:{
    banners:Array
  },
  setup(props,ctx) {
    const toPath = (url) => {
      if (url) {
        ctx.root.$router
          .push({
            path: url
          })
          .catch(() => { });

      }
    }
    return {toPath}
  },
});
</script>

<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
